var $628e140a43dfb330$exports = {};
$628e140a43dfb330$exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " \u81F3 ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "\u5DF2\u9009\u62E9 ".concat(args.date);
  },
  "finishRangeSelectionPrompt": "\u5355\u51FB\u4EE5\u5B8C\u6210\u9009\u62E9\u65E5\u671F\u8303\u56F4",
  "maximumDate": "\u6700\u540E\u4E00\u4E2A\u53EF\u7528\u65E5\u671F",
  "minimumDate": "\u7B2C\u4E00\u4E2A\u53EF\u7528\u65E5\u671F",
  "next": "\u4E0B\u4E00\u9875",
  "previous": "\u4E0A\u4E00\u9875",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "\u9009\u5B9A\u7684\u65E5\u671F\uFF1A".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "\u9009\u5B9A\u7684\u8303\u56F4\uFF1A".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "\u5355\u51FB\u4EE5\u5F00\u59CB\u9009\u62E9\u65E5\u671F\u8303\u56F4",
  "todayDate": function todayDate(args) {
    return "\u4ECA\u5929\uFF0C\u5373 ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "\u5DF2\u9009\u62E9\u4ECA\u5929\uFF0C\u5373 ".concat(args.date);
  }
};
export { $628e140a43dfb330$exports as default };